import { Directive, ElementRef, Input } from '@angular/core';
import { AppState } from '../../config/state';
import { Events } from 'ionic-angular';
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the ScrollArrowsDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[scroll-arrows]', // Attribute selector
})
export class ScrollArrowsDirective {
  @Input() direction: any;
  @Input() buttonType: string = "bars"; //or 'buttons'
  @Input() side: string = "left"; //which side of screen
  @Input() scrollSpeed: number = 100;
  @Input() classToSelect: string;
  @Input() blockSettings: any;
  @Input() inputScrollAmount: number = 0;
  @Input() animated: boolean = true;
  @Input() forceOn: boolean = false;
  upArrowTemplate: string = `<div class="arrowScrollVertical"><i class="fa fa-chevron-up" aria-hidden="true"></i></div>`;
  downArrowTemplate: string = `<div class="arrowScrollVertical"><i class="fa fa-chevron-down" aria-hidden="true"></i></div>`;
  leftArrowTemplate: string = `<div class="arrowScrollHorizontalLeft"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>`;
  rightArrowTemplate: string = `<div class="arrowScrollHorizontalRight"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>`;
  // verticalScrollBarTemplate: string = `<input type="range" name="scroller" min="0" max="100" value="0" step="1" class="scrollArrowRange">`
  scrollIncrement = 200;
  scrollHandle: any;
  masterElement: any;
  leftArrow: any;
  rightArrow: any;
  upArrow: any;
  downArrow: any;
  dot: any;
  lastDragPos: any;

  constructor(private el: ElementRef, private state: AppState, private events: Events, private sounds: SoundsProvider) {
    this.masterElement = this.el.nativeElement;
  }

  ngAfterContentChecked() {
    if ((this.state.scrollArrows || this.forceOn) && this.scrollHandle) {
      if (this.scrollHandle.scrollHeight > this.scrollHandle.clientHeight) {
        this.masterElement.classList.remove('scrollHidden');
      } else {
        this.masterElement.classList.add('scrollHidden');
      }
      this.updateArrows();
    }
  }

  ngAfterViewInit() {
    if (this.blockSettings && this.blockSettings.settings && this.blockSettings.settings.scrollAmount)this.inputScrollAmount = parseInt(this.blockSettings.settings.scrollAmount);
    if ((this.state.scrollArrows || this.forceOn) && this.scrollHandle) {
      this.generateArrows();
      if (this.scrollHandle.scrollHeight <= this.scrollHandle.clientHeight) {
        this.masterElement.classList.add('scrollHidden');
      }
    }
  }
  public update() {
    if ((this.state.scrollArrows || this.forceOn)) {
      this.updateArrows();
    }
  }
  ngOnInit() {
    if ((this.state.scrollArrows || this.forceOn)) {
      if (this.masterElement.tagName === 'ION-SCROLL' || this.masterElement.tagName === 'ION-CONTENT') {
        this.scrollHandle = this.masterElement.getElementsByClassName('scroll-content')[0];
      } else if (this.masterElement.tagName === 'VIRTUAL-SCROLLER') {
        this.scrollHandle = this.masterElement.querySelector('.scrollable-content');
      } else if (this.classToSelect !== undefined && this.classToSelect !== '') {
        this.scrollHandle = this.masterElement.querySelector(`.${this.classToSelect}`);
      } else {
        this.scrollHandle = this.masterElement;
      }
      this.scrollHandle.addEventListener('scroll', (event) => {
        this.updateArrows();
      });
      if (this.masterElement.tagName === 'ION-CONTENT') {
        this.masterElement.classList.add('scroller-content');
      }
    }
  }
  updateArrows() {
    if (!this.scrollHandle) return;
    if (this.direction === 'vertical') {
      if (this.scrollHandle.scrollTop <= 0) {
        this.masterElement.classList.add('at-top');
      } else {
        this.masterElement.classList.remove('at-top');
      }
      if (this.scrollHandle.scrollTop >= (this.scrollHandle.scrollHeight - this.scrollHandle.clientHeight)) {
        this.masterElement.classList.add('at-bottom');
      } else {
        this.masterElement.classList.remove('at-bottom');
      }
      if (this.dot) {
        const p = (this.scrollHandle.scrollTop / (this.scrollHandle.scrollHeight - this.scrollHandle.clientHeight)) * 100;
        this.dot.style.top = `${p}%`;
      }
    } else {
      if (this.scrollHandle.scrollLeft <= 0) {
        this.masterElement.classList.add('at-start');
      } else {
        this.masterElement.classList.remove('at-start');
      }
      if (this.scrollHandle.scrollLeft >= (this.scrollHandle.scrollWidth - this.scrollHandle.clientWidth)) {
        this.masterElement.classList.add('at-end');
      } else {
        this.masterElement.classList.remove('at-end');
      }
    }
  }
  scrollToH(to, duration) {
    if (duration <= 0) {
      this.scrollHandle.scrollLeft = to;
      this.events.publish('horizontalScrollUpdated', to);
      return
    };
    var difference = to - this.scrollHandle.scrollLeft;
    var perTick = difference / duration * 30;

    setTimeout(() => {
      this.scrollHandle.scrollLeft = this.scrollHandle.scrollLeft + perTick;
      this.events.publish('horizontalScrollUpdated', (this.scrollHandle.scrollLeft));
      if (this.scrollHandle.scrollLeft === to) return;
      this.scrollToH(to, duration - 30);
    }, 30);
  }
  scrollToV(to, duration) {
    if(!this.animated){
      this.scrollHandle.scrollTop = to;
      return;
    }
    if (duration <= 0) return;
    var difference = 0;
    difference = to - this.scrollHandle.scrollTop;
    var perTick = difference / duration * 30;
    // console.log('whch', difference, to, duration, perTick, this.blockSettings.settings)
    // console.log(to, duration);
    setTimeout(() => {
      this.scrollHandle.scrollTop = this.scrollHandle.scrollTop + perTick;
      if (this.scrollHandle.scrollTop === to) return;
      this.scrollToV(to, duration - 30);
    }, 30);

    // this.scrollHandle.scrollTop = this.scrollHandle.scrollTop + to;
    // console.log(this.scrollHandle.scrollTop)
  }

  generateArrows() {
    if (this.direction === undefined) {
      console.log('direction not set, defaulting to "vertical"');
      this.direction = 'vertical';
    }
    if (this.direction === 'horizontal') {
      this.leftArrow = document.createElement('div');
      this.leftArrow.classList.add('arrowScrollHorizontalLeft');
      this.leftArrow.classList.add('scrollArrowBar');
      this.leftArrow.innerHTML = '<i class="fa fa-chevron-left" aria-hidden="true"></i>';
      this.masterElement.appendChild(this.leftArrow);
      this.leftArrow.addEventListener("click", () => {
        this.sounds.ButtonClick();
        this.scrollToH((this.scrollHandle.scrollLeft - ((this.scrollHandle.clientWidth/40) * 8)) - 45, this.scrollSpeed);//TODO: remove the 45 fudge factory snap to the colsest element at point
      });


      this.rightArrow = document.createElement('div');
      this.rightArrow.classList.add('arrowScrollHorizontalRight');
      this.rightArrow.classList.add('scrollArrowBar');
      this.rightArrow.innerHTML = '<i class="fa fa-chevron-right" aria-hidden="true"></i>';
      this.masterElement.appendChild(this.rightArrow);
      this.rightArrow.addEventListener("click", () => {
        this.sounds.ButtonClick();
        this.scrollToH((((this.scrollHandle.clientWidth/40) * 8) + this.scrollHandle.scrollLeft) + 45, this.scrollSpeed);//TODO: remove the 45 fudge factory snap to the colsest element at point
      });
    } else if (this.direction === 'vertical') {
      if (this.buttonType === 'bars') {
        this.upArrow = document.createElement('div');
        this.upArrow.classList.add('arrowScrollVerticalUp');
        this.upArrow.classList.add('arrowScroll');
        this.upArrow.innerHTML = '<i class="fa fa-chevron-up" aria-hidden="true"></i>';
        this.masterElement.appendChild(this.upArrow);
        this.upArrow.addEventListener("click", () => {
          this.sounds.ButtonClick();
          this.scrollToV(this.inputScrollAmount ? this.scrollHandle.scrollTop - this.inputScrollAmount : this.scrollHandle.scrollTop - this.scrollHandle.clientHeight, this.scrollSpeed);
        });


        this.downArrow = document.createElement('div');
        this.downArrow.classList.add('arrowScrollVerticalDown');
        this.downArrow.classList.add('arrowScroll');
        this.downArrow.innerHTML = '<i class="fa fa-chevron-down" aria-hidden="true"></i>';
        this.masterElement.appendChild(this.downArrow);
        this.downArrow.addEventListener("click", () => {
          this.sounds.ButtonClick();
          this.scrollToV(this.inputScrollAmount ? this.scrollHandle.scrollTop + this.inputScrollAmount : this.scrollHandle.scrollTop + this.scrollHandle.clientHeight, this.scrollSpeed);
        });

        const barHolder = document.createElement('div');
        barHolder.classList.add('arrowScrollVerticalBarHolder');
        this.masterElement.appendChild(barHolder);

        const bar = document.createElement('div');
        bar.classList.add('arrowScrollVerticalBar');
        barHolder.appendChild(bar);

        let barHeight = bar.getBoundingClientRect().height;
        bar.addEventListener("click", (event) => {
          let newYPercent = (event['layerY'] / barHeight) * 100;
          this.scrollToV((newYPercent * (this.scrollHandle.scrollHeight - this.scrollHandle.clientHeight)) / 100, this.scrollSpeed); //turns percent into pixel
        });

        this.dot = document.createElement('div');
        this.dot.classList.add('arrowScrollVerticalDot');
        //////////////////////////////////////////////////////////////////////////////////////////

        this.dot.addEventListener("mousedown", (event) => {
          this.lastDragPos = event.pageY;
          // console.log(event.pageY)
        });
        this.masterElement.addEventListener("mousemove", (event) => {
          if (this.lastDragPos) {
            this.lastDragPos = event.pageY;
            const bounds = bar.getBoundingClientRect();
            let newYPercent = ((event.pageY - bounds.top) / bounds.height) * 100;
            if (newYPercent < 0) newYPercent = 0;
            if (newYPercent > 100) newYPercent = 100;
            this.scrollHandle.scrollTop = (newYPercent * (this.scrollHandle.scrollHeight - this.scrollHandle.clientHeight)) / 100;

          }
        });
        this.masterElement.addEventListener("mouseup", (event) => {
          this.lastDragPos = null;
        });

        this.dot.addEventListener("touchstart", (event) => {
          this.lastDragPos = event.touches[0].pageY;
          // console.log('start', event.touches[0].pageY)
        });
        this.masterElement.addEventListener("touchmove", (event) => {
          if (this.lastDragPos) {
            this.lastDragPos = event.touches[0].pageY;
            const bounds = bar.getBoundingClientRect();
            let newYPercent = ((event.touches[0].pageY - bounds.top) / bounds.height) * 100;
            if (newYPercent < 0) newYPercent = 0;
            if (newYPercent > 100) newYPercent = 100;
            this.scrollHandle.scrollTop = (newYPercent * (this.scrollHandle.scrollHeight - this.scrollHandle.clientHeight)) / 100;
          }
        });
        this.masterElement.addEventListener("touchend", (event) => {
          this.lastDragPos = null;
        });
        bar.appendChild(this.dot);
      } else {
        this.upArrow = document.createElement('div');
        this.upArrow.classList.add('arrowScrollUp');
        this.upArrow.classList.add('scrollArrowVerticalBar');
        this.upArrow.innerHTML = '<i class="fa fa-chevron-up" aria-hidden="true"></i>';
        this.masterElement.appendChild(this.upArrow);
        this.upArrow.addEventListener("click", () => {
          this.sounds.ButtonClick();
          this.scrollToV((this.inputScrollAmount ? this.scrollHandle.scrollTop - this.inputScrollAmount : this.scrollHandle.scrollTop - this.scrollHandle.clientHeight), this.scrollSpeed);//TODO: remove the 50 fudge factory snap to the colsest element at point
        });


        this.downArrow = document.createElement('div');
        this.downArrow.classList.add('arrowScrollDown');
        this.downArrow.classList.add('scrollArrowVerticalBar');
        this.downArrow.innerHTML = '<i class="fa fa-chevron-down" aria-hidden="true"></i>';
        this.masterElement.appendChild(this.downArrow);
        this.downArrow.addEventListener("click", () => {
          this.sounds.ButtonClick();
          this.scrollToV((this.inputScrollAmount ? this.scrollHandle.scrollTop + this.inputScrollAmount : this.scrollHandle.clientHeight + this.scrollHandle.scrollTop), this.scrollSpeed);//TODO: remove the 50 fudge factory snap to the colsest element at point
        });
      }

    }
    this.updateArrows();
  }
}



// WEBPACK FOOTER //
// ./src/directives/scroll-arrows/scroll-arrows.ts